import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '@edx/frontend-platform/react';
import { getLocale, injectIntl, intlShape } from '@edx/frontend-platform/i18n';

import headerMessages from '../Header.messages';
import DynamicNavigationItem from './DynamicNavigationItem';

const DynamicNavigation = ({ intl }) => {
  const { config } = useContext(AppContext);
  const locale = getLocale();
  const [isUpdating, setIsUpdating] = useState(false);
  const [dynamicNavigation, setDynamicNavigation] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchDynamicNavigation = async () => {
      const url = `${config.LMS_BASE_URL}/asu/navigation/api/config/`;
      setIsUpdating(true);
      try {
        const response = await fetch(url, { credentials: 'include' });
        if (!response.ok) {
          throw new Error(`Response status: ${response.status}`);
        }

        const json = await response.json();

        if (isMounted) {
          setDynamicNavigation(json);
        }
      } catch (error) {
        if (isMounted) {
          setDynamicNavigation([]);
          console.error('Error fetching dynamic navigation:', error.message); // eslint-disable-line no-console
        }
      }
      setIsUpdating(false);
    };

    fetchDynamicNavigation();

    return () => {
      isMounted = false;
    };
  }, [config.LMS_BASE_URL, locale]);

  if (!dynamicNavigation) {
    return null;
  }

  return (
    <nav
      aria-label={intl.formatMessage(headerMessages['header.label.dynamic.nav'])}
      className={`main-dynamic-menu ${isUpdating ? 'updating' : ''}`}
    >
      {dynamicNavigation.map((item) => (
        <DynamicNavigationItem item={item} key={item.label} />
      ))}
    </nav>
  );
};

DynamicNavigation.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(DynamicNavigation);
